import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { breakpoint } from '@zocdoc/components/src/grid';
import { white, navy } from '@zocdoc/branding/colors';
import { sharpSansBold, sharpSansSemibold } from '@zocdoc/components/src/typography';

import { Cities, Specialties, Insurances, AdditionalFilters } from './constants';
import { Container } from '../Panel';
import FilterHeader from './FilterHeader';
import FilterList from './FilterList';
import Anchor from './Anchor';

export class FindDoctorsView extends React.PureComponent {
    static propTypes = {
        trackFindADoctorSearch: PropTypes.func.isRequired,
        trackClickCity: PropTypes.func.isRequired,
        trackClickSpecialty: PropTypes.func.isRequired,
        trackClickInsurance: PropTypes.func.isRequired,
    };

    render() {
        const {
            trackClickCity,
            trackClickSpecialty,
            trackClickInsurance,
        } = this.props;

        return (
            <FindDoctorsPanelContainer>
                <PanelHeader>
                    <FormattedMessage
                        defaultMessage="Find doctors and dentists by..."
                        id="Home.FindDoctors.Header"
                    />
                </PanelHeader>

                <FiltersContainer>
                    <FilterColumn>
                        <FilterHeader
                            href="/locations"
                            iconType="city"
                        >
                            <FormattedMessage
                                defaultMessage="City"
                                id="Home.FindDoctors.City"
                            />
                        </FilterHeader>
                        <FilterList
                            filters={Cities}
                            trackClick={trackClickCity}
                        />
                    </FilterColumn>

                    <FilterColumn>
                        <FilterHeader
                            href="/morespecialties"
                            iconType="specialty"
                        >
                            <FormattedMessage
                                defaultMessage="Specialty"
                                id="Home.FindDoctors.Specialty"
                            />
                        </FilterHeader>
                        <FilterList
                            filters={Specialties}
                            trackClick={trackClickSpecialty}
                        />
                    </FilterColumn>

                    <FilterColumn>
                        <FilterHeader
                            href="/insurances"
                            iconType="insurance"
                        >
                            <FormattedMessage
                                defaultMessage="Insurance"
                                id="Home.FindDoctors.Insurance"
                            />
                        </FilterHeader>
                        <FilterList
                            filters={Insurances}
                            trackClick={trackClickInsurance}
                        />
                    </FilterColumn>
                </FiltersContainer>

                {this.renderFooter(AdditionalFilters)}
            </FindDoctorsPanelContainer>
        );
    }

    renderFooter(additionalFilters) {
        const {
            trackFindADoctorSearch,
        } = this.props;
        const numFilters = additionalFilters.length;
        const footer = ['Or search by '];

        // Create list of filters: '[firstFilter], [middleFilter], ... , [middleFilter], or [lastFilter]'
        for (let i = 0; i < numFilters; i++) {
            const filter = additionalFilters[i];

            const isMiddleFilter = i > 0 && i < (numFilters - 1);
            const isLastFilter = i === (numFilters - 1);

            if (isMiddleFilter) {
                footer.push(', ');
            } else if (isLastFilter) {
                footer.push(', or ');
            }

            footer.push(
                <Anchor
                    key={i}
                    beforeClick={trackFindADoctorSearch}
                    data-filter-name={filter.name}
                    data-test={`find-doctor-by-${filter.name}`}
                    href={`/${filter.url}`}
                >
                    {filter.name}
                </Anchor>
            );
        }

        return (
            <Footer>{footer}</Footer>
        );
    }
}

const FindDoctorsPanelContainer = styled(Container)`
    height: auto !important;
    padding: 60px 0 80px;
    flex-direction: column;

    background-color: ${white};
    background-size: 456px 572px;
    background-repeat: no-repeat;
    background-position: 88px 40px;
`;

const PanelHeader = styled.h3`
    ${sharpSansBold(24, 40)}
    color: ${navy};
`;

const FiltersContainer = styled.div`
    display: flex;
    flex-direction: column;

    ${breakpoint.medium} {
        flex-direction: row;
    }
`;

const FilterColumn = styled.div`
    flex: 1 0;
    min-width: 0;

    ${breakpoint.medium} {
        &:not(:last-child) {
            margin-right: 10%;
        }
    }
`;

const Footer = styled.p`
    color: ${navy};
    ${sharpSansSemibold(14, 28)}
    margin-top: 34px;
`;
